<section aria-labelledby="access-key-title">
  <div class="section-heading">
    <div>
      <h2 id="access-key-title">Access key</h2>
    </div>
  </div>

  <div class="workbench">
    <form class="form-surface" #keyForm="ngForm" (ngSubmit)="submit()">
      <fieldset class="choice-list">
        <legend>Booked items</legend>
        @for (item of requestOptions(); track item.accessId) {
          <label>
            <input
              type="checkbox"
              [checked]="selectedIds().has(item.accessId)"
              (change)="toggleRequest(item.accessId, $any($event.target).checked)"
            >
            <span>{{ item.itemId || item.accessId }}</span>
          </label>
        } @empty {
          <p>No successful access requests are available.</p>
        }
      </fieldset>

      <div class="form-grid">
        <div class="form-field">
          <label for="key-requester">Requester ID</label>
          <input id="key-requester" name="requesterId" class="form-control" [(ngModel)]="requesterId" readonly required>
        </div>
        <div class="form-field">
          <label for="key-language">Language</label>
          <input id="key-language" name="language" class="form-control" [(ngModel)]="language" required>
        </div>
        <div class="form-field full">
          <label for="key-shipper">Shipper name</label>
          <input id="key-shipper" name="shipperName" class="form-control" [(ngModel)]="shipperName" readonly required>
        </div>
        <div class="form-field">
          <label for="key-request-id">Request ID</label>
          <div class="input-group">
            <input id="key-request-id" name="requestId" class="form-control" [ngModel]="requestId()" readonly required>
            <button type="button" class="btn btn-outline-secondary" title="Generate request ID" (click)="regenerateRequestId()">Refresh</button>
          </div>
        </div>
        <div class="form-field">
          <label for="key-user-id">Key user ID</label>
          <input id="key-user-id" name="keyUserId" class="form-control" [(ngModel)]="keyUserId" required>
        </div>
        <div class="form-field">
          <label for="key-algorithm">Key algorithm</label>
          <input id="key-algorithm" class="form-control" [value]="algorithm" readonly>
        </div>
        <div class="form-field">
          <label for="key-encryption">Encryption algorithm</label>
          <input id="key-encryption" class="form-control" [value]="encryption" readonly>
        </div>
      </div>

      <details class="form-section">
        <summary>Public key and SDK identities</summary>
        <div class="form-field form-section-body">
          <label for="key-public-key">Device public key</label>
          <textarea id="key-public-key" class="form-control code-input" rows="5" [value]="publicKey" readonly></textarea>
        </div>
        <div class="identity-heading">
          <span>Lock provider SDK identities</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="addSdkIdentity()">Add identity</button>
        </div>
        @for (identity of sdkIdentities(); track identity.id) {
          <div class="identity-row">
            <input name="sdkKey-{{ identity.id }}" class="form-control" aria-label="SDK identity key" [(ngModel)]="identity.key">
            <span>=</span>
            <input name="sdkValue-{{ identity.id }}" class="form-control" aria-label="SDK identity value" [(ngModel)]="identity.value">
            <button type="button" class="btn btn-outline-danger" title="Remove identity" (click)="removeSdkIdentity(identity.id)">Remove</button>
          </div>
        }
      </details>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="keyForm.invalid || selectedIds().size === 0 || !requestId()">Request keys</button>
      </div>
    </form>

    <div>
      <app-api-endpoint [endpoint]="endpoint" />

      <aside class="guidance-panel" aria-label="Access key instructions">
        <p>A successful booking provides an Item ID in the list on the left.</p>
        <p><strong>Description:</strong> Requests a key from the lock provider. This simulates a driver loading the shipment and departing the terminal.</p>
        <ul>
          <li>Select the Item IDs that represent scanned parcels.</li>
          <li>Submit the form to request keys for the selected parcels.</li>
          <li>For <strong>DROPOFF</strong>, set the Key User ID to the recipient email or phone number.</li>
        </ul>
        <p><strong>Expected Result:</strong> Access keys for the selected parcels.</p>
      </aside>

      @if (selectedRequests().length > 0) {
        <section class="selected-items" aria-labelledby="selected-items-title">
          <h3 id="selected-items-title">Selected parcels</h3>
          <div class="selected-grid">
            @for (item of selectedRequests(); track item.accessId) {
              <article>
                <strong>{{ item.itemId }}</strong>
                <span>{{ item.value['systemProvider'] }}</span>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="toggleRequest(item.accessId, false)">Remove</button>
              </article>
            }
          </div>
        </section>
      }

      @if (accessKeys().length > 0) {
        <section class="table-surface" aria-labelledby="access-keys-result-title">
          <h3 id="access-keys-result-title">Access keys</h3>
          <div class="data-table-wrap">
            <table class="table table-striped align-middle">
              <thead>
                <tr>
                  <th scope="col">Provider</th>
                  <th scope="col">Lockedspace</th>
                  <th scope="col">Item ID</th>
                  <th scope="col">Access key</th>
                  <th scope="col">Type</th>
                </tr>
              </thead>
              <tbody>
                @for (item of accessKeys(); track item['accessId']) {
                  <tr>
                    <td>{{ item['systemProvider'] }}</td>
                    <td>{{ item['displayName'] }}</td>
                    <td>{{ item['itemId'] }}</td>
                    <td><code class="key-value">{{ item['accessKey'] }}</code></td>
                    <td>{{ item['accessType'] }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      }

      <app-api-result
        [endpoint]="endpoint"
        [showEndpoint]="false"
        [request]="call.request()"
        [response]="call.response()"
        [error]="call.error()"
      />
    </div>
  </div>
</section>